import { reducer as sharedFormsReducer } from '../shared/formsReducer';
import getForm from './formsReducerParsers';

export default (state, action) => sharedFormsReducer(state, action, getForm);
